import { render, staticRenderFns } from "./PreTestSubmissionsDetail.vue?vue&type=template&id=ce3441ce&scoped=true"
import script from "./PreTestSubmissionsDetail.vue?vue&type=script&lang=js"
export * from "./PreTestSubmissionsDetail.vue?vue&type=script&lang=js"
import style0 from "./PreTestSubmissionsDetail.vue?vue&type=style&index=0&id=ce3441ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3441ce",
  null
  
)

export default component.exports